/* eslint-disable arrow-body-style */
/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Body, Container, Html, Section, Text } from "@react-email/components";
import PropTypes from "prop-types";

import HeadSection from "../HeadSection";
import FooterSection from "../FooterSection";
import { formatDeliveryDetails } from "../../../components/helper";
import HotelLogo from "../LogoSection/HotelLogo";

const GroceryOrderEmailToLocationStaff = ({ data = {} }) => {
  const {
    food = "groceries",
    firstName = "John",
    lastName = "Doe",
    address = "Dubai, 2/12, UAE",
    unitNumber = "101",
    phone = "1234567890",
    paymentMethod = "stripe",
    cardNumber = "1234",
    email = "guest@example.com",
    type = "room",
    items = [{ ref: { title: "Item 1" }, totalPax: 1 }],
    beverages = [{ name: "Beverage Name", quantity: 1 }],
    locationName = "Holiday Inn",
    createdAt = "12/12/2021",
    scheduleDate = "2025‑04‑23 15:30:00",
    requestTime = "asap",
    currency = "AED",
    locationLogo = "https://email-assets.lokalee.app/email/emailImages/logo.png",
  } = data;
  const isBreakfast = food === "breakfast";
  const orderTypeName = isBreakfast ? "breakfast" : "groceries";

  return (
    <Html>
      <HeadSection />
      <Body
        style={{
          lineHeight: "1.625",
          backgroundColor: "#f7fafc",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <Container
          style={{
            padding: "0",
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto",
            backgroundColor: "#ffffff",
            border: "1px solid #eaeaea",
          }}
        >
          <HotelLogo locationLogo={locationLogo} />
          <Section
            style={{
              textAlign: "left",
              padding: "1.5rem 2rem 1rem 2rem",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "25px",
                color: "#222D29",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              Dear {locationName},
            </Text>
            <Text style={{ fontSize: "24px", color: "#222D29", marginBottom: "0rem" }}>
              A new {orderTypeName} order has just been submitted by your guest. We are reviewing
              the request and will process the order as soon as it is confirmed.
            </Text>
            <Text style={{ fontSize: "24px", color: "#222D29", marginTop: "30px" }}>
              Please find the details below:
            </Text>
          </Section>

          {/* Guest Details Section */}
          <Section
            style={{
              maxWidth: "536px",
              padding: "16px 24px",
              borderRadius: "11.54px",
              backgroundColor: "#F2F2F2",
              margin: "0 auto 20px auto",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "14px",
                color: "#222D29",
                fontWeight: "bold",
                marginBottom: "6px",
                borderBottom: "1px solid #eaeaea",
              }}
            >
              GUEST DETAILS
            </Text>
            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text
                style={{ fontSize: "14px", color: "#222D29", margin: "0px", marginRight: "5px" }}
              >
                {type === "unit" ? "Unit Number:" : "Room Number:"}
              </Text>

              <Text
                style={{
                  margin: "0px",
                  fontSize: "14px",
                  color: "#222D29",
                  fontWeight: "bold",
                }}
              >
                {unitNumber}
              </Text>
            </div>
            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text
                style={{ fontSize: "14px", color: "#222D29", margin: "0px", marginRight: "5px" }}
              >
                First Name:
              </Text>

              <Text
                style={{
                  margin: "0px",
                  fontSize: "14px",
                  color: "#222D29",
                  fontWeight: "bold",
                }}
              >
                {firstName}
              </Text>
            </div>
            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text
                style={{ fontSize: "14px", color: "#222D29", margin: "0px", marginRight: "5px" }}
              >
                Last Name:
              </Text>

              <Text
                style={{
                  margin: "0px",
                  fontSize: "14px",
                  color: "#222D29",
                  fontWeight: "bold",
                }}
              >
                {lastName}
              </Text>
            </div>
            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text
                style={{ fontSize: "14px", color: "#222D29", margin: "0px", marginRight: "5px" }}
              >
                Phone Number:
              </Text>

              <Text
                style={{
                  margin: "0px",
                  fontSize: "14px",
                  color: "#222D29",
                  fontWeight: "bold",
                }}
              >
                {phone}
              </Text>
            </div>

            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text
                style={{ fontSize: "14px", color: "#222D29", margin: "0px", marginRight: "5px" }}
              >
                Email:
              </Text>
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#222D29",
                  margin: "0px",
                }}
              >
                {email}
              </Text>
            </div>
            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text
                style={{
                  fontSize: "14px",
                  color: "#222D29",
                  margin: "0px",
                  marginRight: "5px",
                }}
              >
                Delivery Address:
              </Text>

              <Text
                style={{
                  margin: "0",
                  fontSize: "14px",
                  color: "#222D29",
                  fontWeight: "bold",
                  overflowWrap: "break-word",
                  flex: 1,
                }}
              >
                {address}
              </Text>
            </div>
          </Section>

          <Section
            style={{
              maxWidth: "536px",
              padding: "16px 24px",
              borderRadius: "11.54px",
              backgroundColor: "#F2F2F2",
              margin: "0 auto 24px auto",
            }}
          >
            <Text
              style={{
                fontSize: "13px",
                color: "#222D29",
                margin: "0px",
                marginRight: "5px",
                marginBottom: "16px",
              }}
            >
              Order Date: <strong>{createdAt}</strong>
            </Text>
            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "16px" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #ddd" }}>
                  <th
                    colSpan="2"
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#222D29",
                      textAlign: "left",
                      paddingBottom: "6px",
                    }}
                  >
                    ORDER DETAILS
                  </th>
                  <th
                    style={{
                      width: "100px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#222D29",
                      textAlign: "right",
                      padding: "6px",
                    }}
                  >
                    QUANTITY
                  </th>
                  <th
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#222D29",
                      textAlign: "right",
                      padding: "6px",
                    }}
                  >
                    PRICE
                  </th>
                </tr>
              </thead>

              <tbody>
                {items.map((item) => {
                  const { ref } = item;
                  const itemQuantity = item.totalPax;
                  const itemPrice = item.itemTotalPrice?.price?.recommendedRetailPrice;

                  let displayPrice;
                  if (itemPrice) {
                    displayPrice = `${item.currency || currency} ${itemPrice}`;
                  } else if (isBreakfast) {
                    displayPrice = `${currency}`;
                  } else {
                    displayPrice = "-";
                  }

                  return (
                    <tr key={ref?.title || item.title} style={{ borderBottom: "1px solid #ddd" }}>
                      <td
                        colSpan="2"
                        style={{
                          fontSize: "14px",
                          color: "#222D29",
                          padding: "",
                          textAlign: "left",
                        }}
                      >
                        {ref?.title || item.title}
                      </td>
                      <td
                        style={{
                          width: "100px",
                          fontSize: "14px",
                          color: "#222D29",
                          textAlign: "right",
                          padding: "6px",
                        }}
                      >
                        {itemQuantity}
                      </td>
                      <td
                        style={{
                          width: "100px",
                          fontSize: "14px",
                          color: "#222D29",
                          textAlign: "right",
                          padding: "6px",
                        }}
                      >
                        {displayPrice}
                      </td>
                    </tr>
                  );
                })}
              </tbody>

              {/* Conditionally render the beverages tbody */}
              {isBreakfast && (
                <tbody>
                  {beverages.map((bev) => {
                    const bevName = bev.name;
                    const bevQuantity = bev.quantity || 1;
                    const displayPrice = "-";

                    return (
                      <tr key={bevName} style={{ borderBottom: "1px solid #ddd" }}>
                        <td
                          colSpan="2"
                          style={{
                            fontSize: "14px",
                            color: "#222D29",
                            padding: "6px 0",
                            textAlign: "left",
                          }}
                        >
                          {bevName}
                        </td>
                        <td
                          style={{
                            width: "100px",
                            fontSize: "14px",
                            color: "#222D29",
                            textAlign: "right",
                            padding: "6px",
                          }}
                        >
                          {bevQuantity}
                        </td>
                        <td
                          style={{
                            width: "100px",
                            fontSize: "14px",
                            color: "#222D29",
                            textAlign: "right",
                            padding: "6px",
                          }}
                        >
                          {displayPrice}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </table>

            {isBreakfast && (
              <div style={{ marginTop: "20px" }}>
                <Text
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#222D29",
                    margin: "0px",
                    paddingBottom: "4px",
                    borderBottom: "1px solid #ddd",
                    marginBottom: "4px",
                  }}
                >
                  DELIVERY DETAILS
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    marginTop: "0",
                    color: "#222D29",
                    margin: "0px",
                  }}
                >
                  {formatDeliveryDetails(requestTime, scheduleDate)}
                </Text>
              </div>
            )}

            {paymentMethod === "No Payment Method" ? null : (
              <>
                <Text
                  style={{
                    fontSize: "14px",
                    color: "#222D29",
                    marginTop: "30px",
                    marginBottom: "4px",
                    paddingBottom: "4px",
                    fontWeight: "700",
                    lineHeight: "25.75px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  PAYMENT METHOD
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    marginTop: "0",
                    color: "#222D29",
                  }}
                >
                  {paymentMethod === "stripe" ? `VISA ****${cardNumber}` : paymentMethod}
                </Text>
              </>
            )}
          </Section>

          <Section
            style={{
              textAlign: "left",
              padding: "24px",
              marginLeft: "5px",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "16px",
                color: "#222D29",
              }}
            >
              For any inquiries, we would be happy to assist.
            </Text>{" "}
            <Text
              style={{
                margin: "0px",
                fontSize: "16px",
                color: "#222D29",
                marginBottom: "20px",
              }}
            >
              Please feel free to contact our{" "}
              <a
                href="mailto:cs@lokalee.app"
                style={{
                  fontSize: "16px",
                  color: "#222D29",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                <u>Help Center</u>
              </a>
            </Text>
            <Text
              style={{
                margin: "0px",
                fontSize: "20px",
                fontWeight: "700",
                color: "#222D29",
                marginBottom: "10px",
              }}
            >
              Thank you,
            </Text>
            <Text style={{ fontSize: "20px", color: "#222D29", fontWeight: "400", margin: "0px" }}>
              Lokalee Operations Team
            </Text>
          </Section>
          <FooterSection hasSocialLinks={false} />
        </Container>
      </Body>
    </Html>
  );
};

export default GroceryOrderEmailToLocationStaff;

GroceryOrderEmailToLocationStaff.propTypes = {
  data: PropTypes.shape({
    food: PropTypes.oneOf(["breakfast", "groceries"]),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    address: PropTypes.string,
    unitNumber: PropTypes.string,
    type: PropTypes.string,
    phone: PropTypes.string,
    paymentMethod: PropTypes.string,
    cardNumber: PropTypes.string,
    email: PropTypes.string,
    locationName: PropTypes.string,
    createdAt: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        ref: PropTypes.shape({
          title: PropTypes.string,
        }),
        totalPax: PropTypes.number,
        itemTotalPrice: PropTypes.instanceOf(Object),
        currency: PropTypes.string,
      })
    ),
    beverages: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        quantity: PropTypes.number,
      })
    ),
    scheduleDate: PropTypes.string,
    requestTime: PropTypes.string,
    currency: PropTypes.string,
  }),
};
